import { render } from "./HeaderConfig.vue?vue&type=template&id=6b5d1075"
import script from "./HeaderConfig.vue?vue&type=script&lang=js"
export * from "./HeaderConfig.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__